import React, { Component } from 'react';

class Example extends Component {
  render() {
    return <h1>Examplezz</h1>;
  }
}

export default Example;
